// @ts-ignore - React import for JSX compatibility
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle as MuiDialogTitle,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import styled from 'styled-components';
import { useTranslation } from '../../shared/hooks';
import * as translations from './intl';
import BasicButton from '../Button';

// Styled components replacing makeStyles and withStyles
const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border-radius: 0px;
  }
`;

const StyledDialogTitle = styled(MuiDialogTitle)`
  margin: 0;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledCloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
  color: #9e9e9e;
`;

interface DialogTitleProps {
  children: React.ReactNode;
  onClose?: () => void;
  closelabel?: string;
}

function DialogTitle({ children, onClose, closelabel }: DialogTitleProps) {
  return (
    <StyledDialogTitle>
      {children}
      {onClose && (
        <StyledCloseButton aria-label={closelabel} onClick={onClose}>
          <Close />
        </StyledCloseButton>
      )}
    </StyledDialogTitle>
  );
}

interface ConfirmationModalProps {
  open: boolean;
  handleClose: () => void;
  handleAction: () => void;
  title?: string;
  text?: string;
  okButton?: boolean;
}

function ConfirmationModal({
  open,
  handleClose,
  handleAction,
  title = '',
  text = '',
  okButton = false,
}: ConfirmationModalProps) {
  const { locale: intl } = useTranslation({
    translationsFile: translations,
  });

  const { BUTTON_YES, BUTTON_NO, BUTTON_OK, CLOSE_LABEL } = intl;

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle onClose={handleClose} closelabel={CLOSE_LABEL}>
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </DialogContent>

      <DialogActions>
        {!okButton ? (
          <>
            <BasicButton
              onClick={handleClose}
              variant="outlined"
              color="primary"
              text={BUTTON_NO}
            />
            <BasicButton
              onClick={handleAction}
              variant="contained"
              color="primary"
              text={BUTTON_YES}
            />
          </>
        ) : (
          <BasicButton
            onClick={handleAction}
            variant="contained"
            color="primary"
            text={BUTTON_OK}
          />
        )}
      </DialogActions>
    </StyledDialog>
  );
}

export default ConfirmationModal;
